import { unitMapping } from '#src/lib/style.ts';

type Props = {
  size?: keyof typeof unitMapping;
  className?: string;
};

export const BaseballStartingPitcher = ({ size = 2, className }: Props) => (
  <svg
    className={className}
    style={{ width: unitMapping[size], height: unitMapping[size] }}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.82417 7.3427L7.08837 7.47407L7.76068 8.28548L7.49794 9.746L6.45471 10.6347H3.40229L2.72998 9.82328L3.83503 8.88823L4.27551 9.42917H5.96014L6.19969 9.22825L6.27697 8.78777L6.17651 8.66413L3.91231 8.53276L3.24001 7.72136L3.49502 6.26856L4.53825 5.37988H7.42839L8.06978 6.16037L6.96473 7.09542L6.54744 6.5854H5.03282L4.79326 6.78631L4.72371 7.21906L4.82417 7.3427ZM12.5535 5.37988L13.2799 6.26856L12.9708 8.04592L11.9276 8.9346H9.67882L9.37745 10.6347H7.98647L8.91379 5.37988H12.5535ZM11.4716 7.69818L11.6726 7.52817L11.8039 6.78631L11.6648 6.61631H10.0884L9.8952 7.69818H11.4716Z"
      fill="white"
    />
  </svg>
);
